import one from '../assets/svg/projects/one.svg'
import two from '../assets/svg/projects/two.svg'
import three from '../assets/svg/projects/three.svg'
import four from '../assets/svg/projects/four.svg'
import five from '../assets/svg/projects/five.svg'
import six from '../assets/svg/projects/six.svg'
import seven from '../assets/svg/projects/seven.svg'
import eight from '../assets/svg/projects/eight.svg'
import bike from '../assets/svg/projects/bike.svg'
import travel from '../assets/svg/projects/travel.svg'
import health from '../assets/svg/projects/health-care.svg'

export const projectsData = [
    {
        id: 1,
        projectName: 'Bike-Store',
        projectDesc: 'Responsive MERN Stack app and an Implementation of Admin Management Page. Implemented Authentication System with Firebase. Dashboard and CRUD operation',
        tags: ['React', 'CSS', 'MongoDB', 'Nodejs'],
        code: 'https://github.com/AshrakShohas/Bike-store-MERN-stack-app-website',
        side: 'https://github.com/AshrakShohas/Bike-store-MERN-stack-App-server-side-',
        demo: 'https://bikestore-9e033.web.app/',
        image: bike
    },
    {
        id: 2,
        projectName: 'Travel Agency',
        projectDesc: 'Implemented React router, Fully Responsive for mobile, tablet, and desktop version. Implemented user dashboard and CRUD operation',
        tags: ['React', 'React Bootstrap', 'React Router', 'React Spinners', 'Firebase', 'Heroku'],
        code: 'https://github.com/AshrakShohas/Travel-agency-client-side-',
        demo: 'https://travel-agency-bcd57.web.app/',
        image: travel
    },
    {
        id: 3,
        projectName: 'Health Care Website',
        projectDesc: 'Implemented two Authentication systems, email-password, and Google Sign-in. Fully Responsive for mobile, tablet, and desktop versions.',
        tags: ['React Router', 'CSS', 'Firebase Authentication', 'Firebase Hosting'],
        code: 'https://github.com/AshrakShohas/Healthcare-Website-',
        demo: 'https://health-center-64a51.web.app/home',
        image: health
    },
    {
        id: 4,
        projectName: 'Android Patient Tracker',
        projectDesc: 'This project involves the development of an Android application for viewing and managing patient data.',
        tags: ['Flutter', 'Firebase'],
        code: 'https://github.com/hhhrrrttt222111/developer-portfolio',
        demo: 'https://github.com/hhhrrrttt222111/developer-portfolio',
        image: four
    },
    {
        id: 5,
        projectName: 'E-Commerce App',
        projectDesc: 'A Simple E-commerce application',
        tags: ['React Native', 'Firebase'],
        code: 'https://github.com/hhhrrrttt222111/developer-portfolio',
        demo: 'https://github.com/hhhrrrttt222111/developer-portfolio',
        image: five
    },
    {
        id: 6,
        projectName: 'Uber Lite',
        projectDesc: 'Uber clone',
        tags: ['Flutter'],
        code: 'https://github.com/hhhrrrttt222111/developer-portfolio',
        demo: 'https://github.com/hhhrrrttt222111/developer-portfolio',
        image: six
    },
    {
        id: 7,
        projectName: 'Stock Market App',
        projectDesc: 'A simple stock market API app',
        tags: ['React', 'Redux', 'Bootstrap'],
        code: 'https://github.com/hhhrrrttt222111/developer-portfolio',
        demo: 'https://github.com/hhhrrrttt222111/developer-portfolio',
        image: seven
    },
    {
        id: 8,
        projectName: 'Car Pooling System',
        projectDesc: 'The carpooling system merges multiple people in a car which leads to meet new people, reduces pollution',
        tags: ['Flutter', 'React'],
        code: 'https://github.com/hhhrrrttt222111/developer-portfolio',
        demo: 'https://github.com/hhhrrrttt222111/developer-portfolio',
        image: eight
    },
]


// Do not remove any fields.
// Leave it blank instead as shown below

/*
{
    id: 1,
    projectName: 'Car Pooling System',
    projectDesc: '',
    tags: ['Flutter', 'React'],
    code: '',
    demo: '',
    image: ''
},
*/